var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "things-to-do venue-search",
      class: { "results-loading": _vm.loading }
    },
    [
      _c("div", { staticClass: "things-to-do-container" }, [
        _c("div", { staticClass: "things-to-do-filters" }, [
          _c("div", { staticClass: "things-to-do-filters-inner" }, [
            _c("h3", [_vm._v("WHERE TO SHOP")]),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.getPlaces()
                  }
                }
              },
              [
                _c("div", { staticClass: "text-field keyword-search" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search.keyword,
                        expression: "search.keyword"
                      }
                    ],
                    attrs: { type: "text", placeholder: "KEYWORD SEARCH" },
                    domProps: { value: _vm.search.keyword },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.search, "keyword", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-field",
                    staticStyle: { "margin-right": "20px" }
                  },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search.subcategory,
                            expression: "search.subcategory"
                          }
                        ],
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.search,
                              "subcategory",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("- All Results -")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "covid" } }, [
                          _vm._v("COVID-Friendly")
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search.sort_by,
                          expression: "search.sort_by"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.search,
                            "sort_by",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "most viewed" } }, [
                        _vm._v("Most Popular")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "random" } }, [
                        _vm._v("Random")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "by distance" } }, [
                        _vm._v("By Distance")
                      ])
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "filter-controls" }, [
              _c(
                "a",
                {
                  staticClass: "submit-search",
                  on: {
                    click: function($event) {
                      return _vm.getPlaces()
                    }
                  }
                },
                [_vm._v("SEARCH")]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "things-to-do-content" }, [
          _c("div", { staticClass: "search-results" }, [
            _c("div", { staticClass: "search-details" }, [
              _c("div", { staticClass: "search-details-left" }, [
                _c("span", { staticClass: "search-count" }, [
                  _vm._v(
                    _vm._s(!_vm.loading ? _vm.resultCount : "LOADING") +
                      " RESULTS"
                  )
                ]),
                _vm.activeFilters.search_term
                  ? _c("span", [
                      _vm._v(" | " + _vm._s(_vm.activeFilters.search_term))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "search-details-right" }, [
                _vm.searchActive && !_vm.loading
                  ? _c(
                      "a",
                      {
                        staticClass: "clear-search",
                        on: {
                          click: function($event) {
                            return _vm.clearSearch()
                          }
                        }
                      },
                      [
                        _vm._v("CLEAR SEARCH "),
                        _c("i", { staticClass: "mu-i-cross mu" })
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "things-to-do-loop" },
              _vm._l(_vm.filteredPlaces, function(place, idx) {
                return _c("Venue", {
                  key: "place-" + idx,
                  attrs: { place: place }
                })
              }),
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "things-to-do-load-more" }, [
          _vm.places.length > 0 && _vm.places.length < _vm.resultCount
            ? _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.loadMore()
                    }
                  }
                },
                [_vm._v("LOAD MORE RESULTS")]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/Shopping.vue?vue&type=template&id=8a0719f4&scoped=true&
// module id = 462
// module chunks = 0